export { default } from './AddToCartPopUp.container';
